export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-narrow.cbfd7f25eeeb9a3c51faccf0d41b3ace.webp";